export default __webpack_public_path__ + "static/media/popupConfirm.01b5a8d4.svg";